import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  lineChartData: {
    series: [],
    xAxis: [],
    height: 500,
  },
  lineChartOpen: false,
  selectedLocation: {},
  distributionDataOpen: false,
  distributionDataLoading: false,
  distributionDataTableTitle: null,
  distributionData: [],
};

export const productSalesSlice = createSlice({
  name: "productSales",
  initialState,
  reducers: {
    setLineChartData: (state, action) => {
      state.lineChartData = action.payload;
    },
    setLineChartOpen: (state, action) => {
      state.lineChartOpen = action.payload.value;
    },
    setSelectedLocation: (state, action) => {
      state.selectedLocation = action.payload;
    },
    setDistributionDataOpen: (state, action) => {
      state.distributionDataOpen = action.payload.value;
    },
    setDistributionDataLoading: (state, action) => {
      state.distributionDataLoading = action.payload.value;
    },
    setDistributionDataTableTitle: (state, action) => {
      state.distributionDataTableTitle = action.payload.value;
    },
    setDistributionData: (state, action) => {
      state.distributionData = action.payload.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setLineChartData,
  setLineChartOpen,
  setSelectedLocation,
  setDistributionDataOpen,
  setDistributionDataTableTitle,
  setDistributionData,
  setDistributionDataLoading,
} = productSalesSlice.actions;

export default productSalesSlice.reducer;
